import { MediaQueries } from 'custom_hooks/useWindowSize';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

// Top row metrics widget (full width)
export const TopRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
`;

// Main content area with two columns
export const MainContent = styled.div`
    display: flex;
    gap: 2.4rem;
    flex: 1;
    min-height: 0;

    /* Default layout - side by side columns */
    flex-direction: row;
    overflow: visible;

    /* Switch to column layout on smaller screens */
    @media ${MediaQueries.xlargeAndDown} {
        flex-direction: column;
        gap: 1.6rem;
    }
`;

// Left column containing Issues and Hardware Status
export const LeftColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex: 2;
    gap: 2.4rem;
    min-height: 0;

    & > * {
        /* Default for 1080p - no flex growing */
        flex: 0 0 auto;
        min-height: 0;
    }

    /* Allow flex growing when we have enough vertical space */
    @media (min-height: 1440px) {
        & > * {
            flex: 1 1 auto;
        }
    }
`;

// Right column for unacknowledged alarms
export const RightColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 2.4rem;
    min-height: 0;

    & > * {
        /* Default for 1080p - no flex growing */
        flex: 0 0 auto;
        min-height: 0;
    }

    /* Allow flex growing when we have enough vertical space */
    @media (min-height: 1440px) {
        & > * {
            flex: 1 1 auto;
        }
    }

    @media ${MediaQueries.xlargeAndUp} {
        min-width: 44rem;
        max-width: 58rem;
    }
`;

export const BaseLandingPage = styled.main`
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
    padding: 0 2.5rem 2.5rem;
    margin: 0.8rem auto 0;
    max-width: 176rem;
    box-sizing: border-box;
    overflow: visible;

    > * {
        min-width: 0;
    }

    @media ${MediaQueries.xlargeAndDown} {
        padding-left: 1rem;
        padding-right: 1rem;
    }

    /* Constrain height and prevent scrolling when we have enough vertical space */
    @media (min-height: 1440px) {
        height: calc(
            100vh - 8.7rem
        ); /* Account for nav header (7rem) + top bar border (0.1rem) + content spacing (0.8rem * 2) */
        overflow: hidden;
    }
`;

export const BaseWidgetContainer = styled.div`
    background: ${tokens.card.background};
    border: ${tokens.card.border};
    box-shadow: ${tokens.card.shadow};
    border-radius: 0.8rem;
    box-shadow: ${tokens.elevation['100']};
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 1.6rem;
`;

export const BaseWidgetHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.6rem;
    border-bottom: 0.1rem solid ${tokens.border.default};
`;

export const BaseWidgetTitle = styled.h2`
    font-size: 2.4rem;
    line-height: 1.25;
    font-weight: 500;
    color: ${tokens.text.primary};
    margin: 0;
`;
